// Shared bits for the Customers pages.

export function relativeDays(iso) {
  if (!iso) return 'Never';
  const days = Math.floor((Date.now() - Date.parse(iso)) / 86400000);
  if (days <= 0) return 'Today';
  if (days === 1) return 'Yesterday';
  if (days < 60) return `${days} days ago`;
  return `${Math.round(days / 30)} months ago`;
}

const CHIP = {
  good: { color: 'var(--color-success)', bg: 'var(--color-success-light)' },
  warn: { color: 'var(--color-warning)', bg: 'var(--color-warning-light)' },
  bad: { color: 'var(--color-danger)', bg: 'var(--color-danger-light)' },
  info: { color: 'var(--color-info)', bg: 'var(--color-info-light)' },
  none: { color: 'var(--color-text-tertiary)', bg: 'var(--color-bg-tertiary)' },
};

export function billingLabel(b) {
  if (!b) return { label: 'Unknown', tone: 'none' };
  if (b.kind === 'complimentary') return { label: 'Complimentary', tone: 'info' };
  if (b.kind === 'manual') return { label: 'Manual, no billing', tone: 'info' };
  if (b.kind === 'none') return { label: b.status === 'active' ? 'Active, no billing' : 'No billing', tone: 'warn' };
  switch (b.status) {
    case 'active': return { label: 'Stripe, active', tone: 'good' };
    case 'trialing': return { label: 'Stripe, trial', tone: 'info' };
    case 'past_due': return { label: 'Stripe, past due', tone: 'bad' };
    case 'unpaid': return { label: 'Stripe, unpaid', tone: 'bad' };
    case 'canceled': return { label: 'Stripe, cancelled', tone: 'none' };
    default: return { label: `Stripe, ${b.status || 'unknown'}`, tone: 'warn' };
  }
}

export function BillingChip({ billing }) {
  const { label, tone } = billingLabel(billing);
  const c = CHIP[tone];
  return (
    <span style={{ fontSize: 10, padding: '2px 8px', borderRadius: 'var(--radius-full)', background: c.bg, color: c.color, textTransform: 'uppercase', letterSpacing: '0.04em', whiteSpace: 'nowrap' }}>
      {label}
    </span>
  );
}
